import { ProductListContextProvider, useProductListContext } from "./ProductListContext";
import { useTranslation } from "react-i18next";
import { GridPageHeader } from "src/components/Grid/PageGridHeader";
import { ProductPopover } from "./Popover/ProductPopover";
import { ExtensionPoint, EXTENSION_POINTS } from "src/components/PuckExtensions";

import { NewProductGrid } from "./ProductGrid/NewProductGrid";
import { useMemo } from "react";
import { EntityListLayout } from "src/components/Grid/EntityListLayout";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

const ProductListComponent = () => {
    const { t } = useTranslation();
    const isProductUxV2 = useIsProductUxV2();

    const { globalSearch } = useProductListContext();
    const { search, setSearch } = globalSearch;
    const title = t("product.title", "Mes produits");

    const ProductGrid = useMemo(() => {
        return <NewProductGrid />;
    }, []);

    return (
        <EntityListLayout
            appearance={isProductUxV2 ? "hub" : "legacy"}
            heading={<GridPageHeader title={title} />}
            ariaLabel={title}
            search={{
                value: search,
                onChange: setSearch,
                placeholder: t("rechercher_un_element"),
                showOnDesktop: false,
            }}
            actions={<ProductPopover />}
            beforeGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_LISTING_HEADER} priority="high" />}
            afterGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.PRODUCT_LISTING_FOOTER} priority="high" />}
            hideHeadingOnMobile
        >
            {ProductGrid}
        </EntityListLayout>
    );
};

const ProductList = () => {
    return (
        <ProductListContextProvider>
            <ProductListComponent />
        </ProductListContextProvider>
    );
};
export default ProductList;
